<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,computed } from 'vue'
import CustomList from "../../../compositions/CustomList.vue";
import SelectBox from "../../../compositions/SelectBox.vue";
import TextBox from "../../../compositions/TextBox.vue";
import ModalDialog from "../../../compositions/ModalDialog.vue";
import config from "../../../config.js";
import { errorAlert,confirmAlert } from "../../../plugins/alert";
import { getFieldValue } from "../../../plugins/utility";
import qs from 'qs';
import axios from '../../../plugins/axios.ts';
import HelpAction from '../../../compositions/HelpAction.vue';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    wholesalers:{
      type:Array,
      required:true,
    },
    placeHolder:{
        type:String,
        default: () => {
            return '';
        }
    }
})
const listRef = ref();
const selectWholesalerId = ref(0);
const selectWholesalerName = ref('');
const inputRefundPrice = ref(0);
const inputRefundTax = ref(config.DEFAULT_TAX);
const inputRefundDate = ref('');
const optionFields = ref({
  'page_size' : 30,
});
const fields = ref([
  {field_name: '金額調整日', field_key: 'refund_date', width: '20%', align: 'text-center', sorted:true},
  {field_name: '卸名', field_key: 'wholesaler.wholesaler_name', width: '60%', align: 'text-left', sorted:true},
  {field_name: '金額', field_key: 'price', width: '10%', align: 'text-left', sorted:true},
  {field_name: '消費税', field_key: 'tax', width: '10%', align: 'text-left', sorted:false},
  {field_name: '作成日', field_key: 'created_at', width: '20%', align: 'text-center', sorted:false},
  {field_name: '作成者', field_key: 'create_user_name', width: '20%', align: 'text-center', sorted:false},
  {field_name: '', field_key: 'action', width: '20%', align: 'text-center'}
]);

const handler = (name:string,value:Object,eof:Boolean=false) => {
}
const selectBoxHandler = (value,label) => {
  selectWholesalerId.value = value;
  selectWholesalerName.value = label;
}
const inputBoxHandler = (value,option) => {
  if (option.field == 'price') {
    inputRefundPrice.value = value;
  } else if (option.field == 'tax') {
    inputRefundTax.value = value;
  }
}
const inputDateBoxHandler = (value) => {
  inputRefundDate.value = value;
}
const isShowAddDialog = ref(false);
const showAddDialog = () => {
  isShowAddDialog.value = true;
}
const closeAddDialog = () => {
  isShowAddDialog.value = false;
}
const isAddLoading = ref(false);
const addRefund = () => {
  if (!inputRefundPrice.value) {
    errorAlert('金額を入力してください。');
    return;
  }
  if (!inputRefundTax.value) {
    errorAlert('消費税(%)を入力してください。');
    return;
  }
  if (!inputRefundDate.value) {
    errorAlert('日付を入力してください。');
    return;
  }
  isAddLoading.value = true;
  let params = new FormData();
  params.append('wholesaler_id',selectWholesalerId.value);
  params.append('price',inputRefundPrice.value);
  params.append('tax',inputRefundTax.value);
  params.append('refund_date',inputRefundDate.value);
  axios(props.apis.pharmacy_update_refund,{method:"post",data:params})
  .then((response) => {
    isShowAddDialog.value = false;
    listRef.value.resetItem(config.LIST_DELAY);
  })
  .catch((error) => {
    isAddLoading.value = false;
    errorAlert(error);
  })
  .then(() => {
    //always
    isAddLoading.value = false;
  });
}
const isLoadingDialog = ref(false);
const deletePharmacyRefundConfirm = async (item) => {
  let result = await confirmAlert('削除してもよろしいですか？');
  if (result.isConfirmed) {
    deletePharmacyRefund(item);
  }
}
const deletePharmacyRefund = (item) => {
  isLoadingDialog.value = true;
  let params = new FormData();
  params.append('refund_id', item.id);
  axios(props.apis.pharmacy_delete_refund,{method:"post",data:params})
  .then((response) => {
    listRef.value.deleteItem(item);
  })
  .catch((error) => {
    isLoadingDialog.value = false;
    errorAlert(error);
  })
  .then(() => {
    isLoadingDialog.value = false;
  });
}
</script>

<style scoped>
</style>
<template>
<div ref="element" class="relative">
  <div class="absolute top-2 left-2">
    <help-action
      help-key="order_help"
    ></help-action>
  </div>
  <div class="w-full flex items-center justify-end p-2 bg-gray-100 rounded">
      <div>
          <a href="javascript:void(0)" @click="showAddDialog" class="block text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 font-medium rounded-lg text-base px-5 py-3 w-full sm:w-auto text-center ml-2">金額調整追加</a>
      </div>
  </div>
  <div class="w-full">
      <custom-list
        ref="listRef"
        :table-fields="fields"
        :api-url="apis.pharmacy_refund_list"
        :option-fields="optionFields"
        height="72vh"
        :handler="handler"
      >
      <template v-slot:item="slotProps">
        <td v-for="(field,index) in fields" :style="'width:' + field.width" :class="field.align">
          <div v-if="field.field_key == 'action'" :class="field.align">
            <a href="javascript:void(0)" @click="deletePharmacyRefundConfirm(slotProps.item)"><i class="fa-solid fa-trash-can"></i></a>
          </div>
          <div v-else-if="field.field_key == 'price'" :class="field.align">
            \{{ slotProps.item.price.toLocaleString() }}
          </div>
          <div v-else-if="field.field_key == 'tax'" :class="field.align">
            {{ Number(slotProps.item.tax * 100) }}%
          </div>
          <div v-else-if="field.field_key == 'create_user_name'" :class="field.align">
            {{ (slotProps.item.create_user ? slotProps.item.create_user.username : '') }}
          </div>
          <div v-else :class="field.align">
            {{ getFieldValue(slotProps.item,field.field_key) }}
          </div>
        </td>
      </template>
      </custom-list>
      <div></div>
  </div>
</div>
<modal-dialog
  :is-visible="isLoadingDialog"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isShowAddDialog"
  width="60%"
  :close="closeAddDialog"
  :isLoading="isAddLoading"
>
  <template v-slot:header>
    金額調整登録
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <table class="w-full">
      <tr class="border-b border-white">
        <th class="block px-3 py-2 text-left md:table-cell md:w-1/2 md:text-sm">
          卸業者
        </th>
        <td class="block py-3 text-sm md:table-cell md:w-1/2 md:px-3 md:py-2">
          <select-box
            :options="wholesalers"
            :on-change="selectBoxHandler"
            list-field-name="wholesaler_name"
            :value="selectWholesalerId"
            :is-searchable="false"
          ></select-box>
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 text-left md:table-cell md:w-1/2 md:text-sm">
          金額調整金額<span class="text-red-500 font-bold"><br>※値引き金額を入力する際はマイナスを付けずに入力してください。</span>
        </th>
        <td class="block py-3 text-sm md:table-cell md:w-1/2 md:px-3 md:py-2">
          <text-box
            type="number"
            :value-options="{field:'price'}"
            :is-focus-clear="true"
            :on-change="inputBoxHandler"
            :value="inputRefundPrice"
          ></text-box>
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 text-left md:table-cell md:w-1/2 md:text-sm">
          消費税(%)
        </th>
        <td class="block py-3 text-sm md:table-cell md:w-1/2 md:px-3 md:py-2">
          <text-box
            type="number"
            :value-options="{field:'tax'}"
            :is-focus-clear="true"
            :on-change="inputBoxHandler"
            :value="inputRefundTax"
          ></text-box>
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 text-left md:table-cell md:w-1/2 md:text-sm">
          金額調整日
        </th>
        <td class="block py-3 text-sm md:table-cell md:w-1/2 md:px-3 md:py-2">
          <text-box
            type="date"
            :on-change="inputDateBoxHandler"
            :value="inputRefundDate"
          ></text-box>
        </td>
      </tr>
    </table>
  </div>
  <div class="flex">
    <div class="flex-row mr-2">
      <button type="button" @click="addRefund" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">登録する</button>
    </div>
    <div class="flex-row">
      <button type="button" @click="closeAddDialog" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
    </div>
  </div>
  </template>
</modal-dialog>

</template>

